import { render } from "./CraftopiaView.vue?vue&type=template&id=1682f4e3"
import script from "./CraftopiaView.vue?vue&type=script&lang=js"
export * from "./CraftopiaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__